export enum Tabs {
  Overview = "overview",
  Approvals = "approvals"
}
